import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  BooleanField,
  SlugField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Role Schema - For multi-role system
 *
 * Defines available roles in the system.
 * Users can have multiple roles through user_roles_lnk junction table.
 */

// Define role fields
const RoleFields = {
  role_code: SlugField({
    title: 'Код роли',
    unique: true,
    description:
      'Уникальный технический идентификатор роли в формате UPPERCASE (например, ADMIN, USER, CRM_MANAGER). Используется для FK и проверки прав.',
  }),

  name: StringField({
    title: 'Название роли',
    minLength: 1,
    maxLength: 50,
    description: 'Человекочитаемое название роли (может изменяться)',
  }),
  description: StringField({
    title: 'Описание',
    maxLength: 255,
    nullable: true,
    description: 'Описание роли',
  }),
  is_active: BooleanField({
    title: 'Активна',
    default: true,
    description: 'Активна ли роль',
  }),
};

// Complete role schema with system fields
export const RoleSchema = Type.Object({
  ...SystemFields,
  ...RoleFields,
});

// Export types
export type Role = Static<typeof RoleSchema>;

export default defineSchema({
  moduleName,
  tableName: 'roles',
  schema: RoleSchema,
  dependencies: [],
});
